export default __webpack_public_path__ + "static/media/img-03.79c3ced5.jpg";